<template>
  <div class="home survey-results font_Montserrat v3_color_black_knight">
    <div class="survey-results__content">
      <div class="mobile-reponsive-padding-box">
        <h2 class="font_size_1000rem font_weight_bold mobile-reponsive-heading">
          <template v-if="specialty">
            Specialty: {{ specialtyTitle }}
          </template>
          <template v-if="subspecialty">
            / Subspecialty: {{ subspecialtyTitle }}
          </template>
        </h2>
        <b-card no-body class="v3_box_teal mt-4">
          <div class="v3_box_teal_header">
            <div v-if="isQuestionnaireSupportsReports || isPresentationResults">
              <b-row>
                <b-col md="7" lg="8" xl="9" sm="12">
                  <b-row class="h-100 mobile-header-content-center">
                    <b-col
                      md="12"
                      lg="12"
                      xl="5"
                      class="d-flex align-items-center"
                    >
                      <span
                        class="v3_color_teal font_size_1250rem font_weight_bold"
                      >
                        {{ pageTitle }}
                      </span>
                    </b-col>
                    <b-col
                      v-if="comparison"
                      md="12"
                      lg="5"
                      xl="3"
                      class="d-flex align-items-center"
                    >
                      <div
                        class="v3_color_teal font_size_850rem d-flex flex-column"
                      >
                        <span class="font_weight_bold">Report Name:</span>
                        {{ comparison.title }}
                      </div>
                    </b-col>
                    <b-col
                      md="12"
                      lg="7"
                      xl="4"
                      class="d-flex align-items-center"
                    >
                      <div
                        class="v3_color_teal font_size_850rem d-flex flex-column"
                      >
                        <div class="font_weight_bold">Study Period:</div>
                        <div>
                          {{ questionnaireStartDate }} -
                          {{ questionnaireClosedDate }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  cols="12"
                  md="5"
                  lg="4"
                  sm="12"
                  xl="3"
                  class="d-flex flex-sm-row flex-column justify-content-start justify-content-sm-start justify-content-md-end align-items-md-center my-md-0 my-2"
                >
                  <take-study-with-profile-validation-behaviour
                    :questionnaire="questionnaire"
                    v-if="
                      !userHasDoneASurvey &&
                      !isPresentationResults &&
                      !isAdminResults
                    "
                  >
                    <template
                      slot-scope="{
                        takeStudyHandler,
                        takeStudyLoading,
                        isStudyCanBeTaken,
                      }"
                    >
                      <b-button
                        id="take-study-button"
                        variant="v3_teal_outline"
                        class="mr-sm-2 mb-2 mb-sm-0"
                        :disabled="takeStudyLoading || !isStudyCanBeTaken"
                        @click="takeStudyHandler"
                      >
                        <b-spinner v-if="takeStudyLoading" small />
                        <span v-else>Take Study</span>
                      </b-button>
                      <b-tooltip
                        target="take-study-button"
                        :disabled="!isStudyCanBeTaken"
                      >
                        Take the study to activate all the features.
                      </b-tooltip>
                    </template>
                  </take-study-with-profile-validation-behaviour>                  
                    <div class="pl-1 d-flex align-items-center" v-if="this.questionnaire && this.questionnaire.isPrimary">
                              <span id="new-report-btn">
                                <b-button
                                        variant="v3_teal_outline"
                                        class="ml-2"
                                        @click="newComparison"
                                        :disabled="
                                    !userHasDoneASurvey || isPresentationResults
                                  "
                                >
                                  New
                                </b-button>
                                <b-tooltip
                                        target="new-report-btn"
                                        triggers="hover"
                                        :disabled="!isPresentationResults"
                                >
                                  The New feature is disabled in the sample
                                  version of Reports. Phairify members can
                                  create and customize as many reports as they
                                  like.
                                </b-tooltip>
                              </span>
                        <b-button
                                variant="v3_teal_outline"
                                class="ml-2 mobile-select-margin"
                                @click="showSelectComparisonModal = true"
                                :disabled="
                                  comparisonOptions.length <= 1 ||
                                  (!userHasDoneASurvey &&
                                    !isPresentationResults)
                                "
                        >
                            Load
                        </b-button>
                        <span class="mt-1">
                                <b-dropdown
                                        variant="dots"
                                        no-caret
                                        right
                                        menu-class="border_0 shadow-lg"
                                >
                                  <template slot="button-content">
                                    <div class="d-flex align-items-center">
                                      <i
                                              v-b-tooltip.hover
                                              title="Select actions for Reports"
                                              class="mdi mdi-dots-vertical phairify-icon-size-36 ml-n2"
                                      />
                                    </div>
                                  </template>
                                  <span id="rename-dropdown-item">
                                    <b-dropdown-item
                                            @click="onEditComparison"
                                            :disabled="
                                        !isComparison ||
                                        !userHasDoneASurvey ||
                                        isPresentationResults
                                      "
                                            class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray"
                                    >
                                      Rename
                                    </b-dropdown-item>
                                    <b-tooltip
                                            target="rename-dropdown-item"
                                            triggers="hover"
                                            placement="lefttop"
                                            :disabled="!isPresentationResults"
                                    >
                                      The Rename feature is disabled in the
                                      sample version of Reports
                                    </b-tooltip>
                                  </span>
                                  <span id="copy-dropdown-item">
                                    <b-dropdown-item
                                            @click="cloneComparison"
                                            :disabled="
                                        !isComparison ||
                                        !userHasDoneASurvey ||
                                        isPresentationResults
                                      "
                                            class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray"
                                    >
                                      Copy
                                    </b-dropdown-item>
                                    <b-tooltip
                                            target="copy-dropdown-item"
                                            triggers="hover"
                                            placement="lefttop"
                                            :disabled="!isPresentationResults"
                                    >
                                      The Copy feature is disabled in the sample
                                      version of Reports
                                    </b-tooltip>
                                  </span>
                                  <span id="delete-dropdown-item">
                                    <b-dropdown-item
                                            @click="onDeleteComparison"
                                            :disabled="
                                        !isComparison || !userHasDoneASurvey
                                      "
                                            class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray v2_color_red"
                                    >
                                      Delete
                                    </b-dropdown-item>

                                    <b-tooltip
                                            target="delete-dropdown-item"
                                            triggers="hover"
                                            placement="lefttop"
                                            :disabled="!isPresentationResults"
                                    >
                                      The Delete feature is disabled in the
                                      sample version of Reports
                                    </b-tooltip>
                                  </span>
                                </b-dropdown>
                              </span>
                    </div>
                  <template v-if="!isAdminResults">
                    <b-button
                      v-if="userHasDoneASurvey && !isPresentationResults"
                      variant="v3_teal_outline"
                      class="text-nowrap"
                      @click="onGenerateReport"
                      :disabled="reportsLoading"
                    >
                      <template>
                        <span
                          v-if="reportsLoading"
                          class="downloading-report-span"
                          >Downloading <b-spinner small
                        /></span>
                        <span v-else>Download Report</span>
                      </template>
                    </b-button>
                    <b-button
                      v-else
                      v-b-tooltip
                      title="Only a sample report is available until the study is completed."
                      variant="v3_teal_outline"
                      class="text-nowrap"
                      target="_blank"
                      :href="sampleReportLink"
                    >
                      Download Report
                    </b-button>
                  </template>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="v3_box_teal_body p-4 mobile-reponsive-box-body-padding" style="min-height: 400px">
            <div
              class="box-body-color-padding"
              v-if="isQuestionnaireSupportsReports || isPresentationResults"
            >
              <b-row>
                
                <!-- Filters column -->
                <b-col md="6" lg="4" class="mb-5" v-if="!isOptionsHidden">
                  
                  <div class="p-2 border_1 border_grey">
                    <!-- comparisons -->
                    <v-wait :for="`${$options.name}_loading`">
                      <template slot="waiting">
                        <HalfCircleSpinner />
                        <div class="spinner-message my-3 text-center">
                          Checking reports data...
                        </div>
                      </template>
                      <template>
                        <!-- <div
                          :class="[{ 'with-instruction': isComparisonEmpty || this.isChartInformation }]"
                        >
                          <h2
                            v-if="(isComparisonEmpty || this.isChartInformation) && resultsSorted.length == 0"
                            class="instruction d-flex flex-column align-items-start"
                          >
                            <div class="d-flex align-items-center">
                              <span v-if="isPresentationResults">
                                STEP 1 - Create a New report or Select a saved
                                report [disabled in sample version].
                              </span>
                              <span v-else>
                                STEP 1 - Select Measures to view aggregate data for your specialty.
                              </span>
                            </div>
                            <div class="mt-4 pt-1 d-flex align-items-center">
                              <span v-if="isPresentationResults">
                                STEP 2 - Select the Data Source you would like
                                to view for your report [fixed in sample
                                version]
                              </span>
                              <span v-else>
                                STEP 2 - Select and apply Filters to fine-tune the aggregate data.
                                <p class="font-note mt-4">Note: Measures display aggregated data from all ACS member participants. 
                                To see data from a specific specialty or subspecialty, select the applicable filter(s).</p>
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <div class="d-flex">
                                <div style="white-space: nowrap">
                                </div>
                                <div>
                                </div>
                              </div>
                            </div>
                          </h2>
                        </div> -->
                        <!-- Measures -->
                        <b-row>
                          <b-col>
                            <div class="">
                              <b-row class="align-items-center">
                                <b-col class="text-nowrap mb-2 text-left">
                                  <span class="v3_color_teal font_size_850rem font_weight_bold">
                                    Step 1: Measures
                                    <span v-if="numberOfSelectedQuestions">
                                      ({{ numberOfSelectedQuestions }})
                                    </span>
                                  </span>
                                </b-col>
                                <!-- TODO: refresh on load to show any new questions -->
                                <b-col class="text-center">
                                  <ChartsPicker
                                    v-if="this.questionnaire"
                                    button-class="w-100"
                                    items-name="Measures"
                                    ref-id="add-question"
                                    :questionnaire="this.questionnaire"
                                    :ids="comparison ? comparison.charts : {}"
                                    :favorites="favorites"
                                    @selected="onChartsSelected"
                                    :is-disabled="!isComparison"
                                    :tooltip-text="`Choose measures to display in ${
                                      format === 'filters'
                                        ? 'the report'
                                        : 'results'
                                    }`"
                                    :apply-tooltip-text="`Apply selections to ${
                                      format === 'filters'
                                        ? 'the report'
                                        : 'results'
                                    }`"
                                    :is-on-dashboard-only-selectable="
                                      !userHasDoneASurvey &&
                                      !isPresentationResults &&
                                      !isAdminResults
                                    "
                                    :selected-section="selectedSection"
                                    :completed-modules="modules"
                                  />
                                </b-col>
                              </b-row>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col v-if="!isComparisonEmpty">
                            <SurveySelectedCharts
                              :questions="questions"
                              :questionnaire="questionnaire"
                              :comparison="comparison"
                              :results-sorted="resultsSorted"
                              :tooltip-title="`Remove this measure from ${
                                format === 'filters' ? 'the report' : 'results'
                              }`"
                              :is-profile-visible="
                                !!questionnaire.supports_profile_measures
                              "
                              @remove-question="removeQuestionFromCharts"
                              @remove-der-var="removeDerVar"
                            />
                            <hr class="border_black_knight" />
                            <!-- filters -->
                            <div
                              v-if="
                                format === 'filters' ||
                                isPresentationResults ||
                                isAdminResults
                              "
                              :class="[
                                { 'with-instruction': isComparisonEmpty },
                              ]"
                            >
                              <!-- Select filters UI  -->
                              <filters-selector
                                ref="filtersSelector"
                                :key="selectedSection || 'all'"
                                :questionnaire="this.questionnaire"
                                :initial-filters="
                                  comparison ? comparison.filters : {}
                                "
                                :initial-filter-values="
                                  comparison ? comparison.filterValues : {}
                                "
                                :is-membership-section-visible="
                                  isMembershipSectionVisible
                                "
                                :membership-options="membershipOptions"
                                :disabled="
                                  !userHasDoneASurvey &&
                                  !isPresentationResults &&
                                  !isAdminResults
                                "
                                :selected-section="selectedSection"
                                :completed-modules="modules"
                                @filters-apply="onFiltersApply"
                                @set-tags="variableTags = $event"
                              />
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </v-wait>
                  </div>
                </b-col>
                <!-- Results column -->
                <b-col md="6" lg="8" class="py-0">

                  <div v-if="!isOptionsHidden"
                          :class="[{ 'with-instruction': isComparisonEmpty || this.isChartInformation }]"
                        >
                          <h2
                            v-if="(isComparisonEmpty || this.isChartInformation) && resultsSorted.length == 0"
                            class="instruction d-flex flex-column align-items-start"
                          >
                            <div class="d-flex align-items-center">
                              <span v-if="isPresentationResults">
                                STEP 1 - Create a New report or Select a saved
                                report [disabled in sample version].
                              </span>
                              <span v-else>
                                STEP 1 - Select Measures to view aggregate data for your specialty.
                              </span>
                            </div>
                            <div class="mt-4 pt-1 d-flex align-items-center">
                              <span v-if="isPresentationResults">
                                STEP 2 - Select the Data Source you would like
                                to view for your report [fixed in sample
                                version]
                              </span>
                              <span v-else>
                                STEP 2 - Select and apply Filters to fine-tune the aggregate data.
                                <p class="font-note mt-4">Note: Measures display aggregated data from all ACS member participants. 
                                To see data from a specific specialty or subspecialty, select the applicable filter(s).</p>
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <div class="d-flex">
                                <div style="white-space: nowrap">
<!--                                  STEP 4 - &nbsp;-->
                                </div>
                                <div>
<!--                                  After you have selected a Measure, set Filters-->
<!--                                  to fine-tune the displayed data.-->
                                </div>
                              </div>
                            </div>
                          </h2>
                  </div>

                  <div class="flex-md-row">
                    <div>
                      <survey-result-tags
                        :key="(comparison || {}).title"
                        :tags="variableTags"
                        @remove-tag="onRemoveTag"
                        @clear-all="onTagClearAll"
                      />
                    </div>
                  </div>

                  <v-wait :for="`${$options.name}_loading`">
                    <template slot="waiting">
                      <HalfCircleSpinner />
                      <div class="spinner-message my-3 text-center">
                        Checking reports data...
                      </div>
                    </template>
                    <template>
                      <div
                        v-for="(res, index) in resultsSorted"
                        :key="res.id || index"
                      >
                        <b-card
                          no-body
                          class="mx-auto h-100 rounded-0 border_1 border_grey v3_bg_transparent mb-2"
                          v-if="preloadQuestion(index)"
                        >
                          <b-card-header v-if="res && res.chart_title">
                            <b-row>
                              <b-col
                                cols="10"
                                class="d-flex align-items-center"
                              >
                                <h2
                                  class="survey-results__question-prompt phairify-color-navy mb-0"
                                >
                                  <strong>
                                    {{ res.chart_title }}
                                  </strong>
                                </h2>
                              </b-col>
                              <b-col cols="2" class="text-right">
                                <i
                                  v-if="res.question"
                                  class="mdi mdi-help-circle-outline phairify-color-navy"
                                  aria-hidden="true"
                                  :id="`chart_question_tooltip_${res.id}`"
                                  @mouseover="onTooltipMouseOver(index)"
                                  @mouseout="onTooltipMouseOut(index)"
                                />
                              </b-col>
                            </b-row>

                            <b-tooltip
                              v-if="res.question"
                              ref="chart_question_tooltips"
                              :target="`chart_question_tooltip_${res.id}`"
                              placement="left"
                            >
                              <div
                                v-html="replaceCustomTags(res.question.prompt)"
                              />
                            </b-tooltip>
                          </b-card-header>
                          <b-card-body>
                            <div v-if="res && res.insufficient">
                              <b-alert show variant="warning">
                                There is not enough data to display.
                              </b-alert>
                            </div>
                            <div
                              v-else-if="
                                res && res.results && !res.results.length
                              "
                            >
                              <b-alert show variant="warning">
                                No results found.
                              </b-alert>
                            </div>
                            <div v-else-if="res">
                              <ChartBuilder
                                :result="res"
                                :format="chartFormat"
                                :comparison="comparison"
                                :is-title-visible="false"
                                :is-border-visible="false"
                              />
                            </div>
                          </b-card-body>
                        </b-card>
                      </div>
                    </template>
                  </v-wait>
                </b-col>
              </b-row>
            </div>

            <div
              class="survey-results__loading-indicator width_400"
              v-if="this.preloading || questionnaireLoading"
            >
              <b-alert
                show
                variant="warning"
                class="d-flex justify-content-left align-items-center py-2"
              >
                <HalfCircleSpinner class="v2" />
                <span
                  v-if="variableTags && Object.keys(variableTags).length !== 0"
                >
                  Applying filters…
                </span>
                <template v-else>
                  <span>Loading</span>
                  &ensp;
                  <span v-if="questionnaireLoading">study ...</span>
                  <span v-else>charts ...</span>
                </template>
              </b-alert>
            </div>

            <reports-placeholder-image
              v-else-if="isQuestionnaireNotSupportsReports && !preloading"
              :questionnaire-report-image="
                questionnaire ? questionnaire.report_image : null
              "
            />
            <b-row
              v-else-if="!questionnaire && !preloading && !questionnaireLoading"
            >
              <b-col
                cols="12"
                class="mt-3 d-flex justify-content-center align-items-center ml-2"
              >
                <p class="v2_font_size_18">
                  There are no studies to view data for. Please check back later
                  or view your available studies.
                </p>
              </b-col>
            </b-row>
            <div
              v-if="
                format === 'filters' &&
                isWithReport &&
                (userHasDoneASurvey || isPresentationResults)
              "
              class="report-markdown-wrapper"
            >
              <!--              <div ref="reportMarkdownInfo">-->
              <!--                <report-markdown-info-->
              <!--                  :study="questionnaire"-->
              <!--                  :result-titles="resultTitles"-->
              <!--                  @ready="onReportReady"-->
              <!--                >-->
              <!--                  <report-markdown-filters-->
              <!--                    v-if="!isFiltersEmpty"-->
              <!--                    slot="filters"-->
              <!--                    :filters="comparison ? comparison.filters : {}"-->
              <!--                    :filter-values="comparison ? comparison.filterValues : {}"-->
              <!--                    :membership-options="membershipOptions"-->
              <!--                    :questionnaire="questionnaire"-->
              <!--                  />-->
              <!--                </report-markdown-info>-->
              <!--              </div>-->
              <div>
                <report-markdown-charts
                  :study="questionnaire"
                  @ready="onReportReady"
                >
                  <b-container
                    ref="reportMarkdownCharts"
                    v-for="(res, index) in resultsSorted"
                    :key="index"
                  >
                    <report-markdown-heading
                      :measure="res.chart_title"
                      :study="questionnaire"
                      :result-titles="resultTitles"
                      class="report-pdf-item report-pdf-heading"
                    >
                      <report-markdown-filters
                        v-if="!isFiltersEmpty"
                        slot="filters"
                        :filters="comparison ? comparison.filters : {}"
                        :filter-values="
                          comparison ? comparison.filterValues : {}
                        "
                        :membership-options="membershipOptions"
                        :questionnaire="questionnaire"
                      />
                    </report-markdown-heading>
                    <b-card class="rounded-0 border-0" body-class="px-0">
                      <b-card-body>
                        <div v-if="res && res.insufficient" class="report-pdf-item">
                          <b-alert show variant="warning">
                            There is not enough data to display.
                          </b-alert>
                        </div>
                        <div class="report-pdf-item"
                          v-else-if="res && res.results && !res.results.length"
                        >
                          <b-alert show variant="warning">
                            No results found.
                          </b-alert>
                        </div>
                        <chart-builder
                          v-else
                          class="mb-2"
                          format="results"
                          :result="res"
                          :comparison="comparison"
                          :is-title-visible="false"
                          :is-with-report="isWithReport"
                        />
                      </b-card-body>
                    </b-card>
                  </b-container>
                  <b-container
                    slot="charts-footer"
                    ref="reportMarkdownChartsFooter"
                  >
                    <p class="mb-0 v2_font_size_20 v2_font_weight_semibold">
                      {{ questionnaire.title }} – User Report &nbsp; &nbsp;
                      &nbsp; &nbsp;
                      {{ $dayjs().format('MMM D, YYYY h:mm A') }}
                    </p>
                  </b-container>
                </report-markdown-charts>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!-- end if userHasDoneASurvey -->
    </div>

    <create-comparison-modal
      v-if="showNewComparisonModal"
      :initial-title="(editedComparison || {}).title"
      :is-edit-type="!!editedComparison"
      :comparison-titles="comparisonTitles"
      @modalSave="onModalSave"
      @modalCancel="onCancelComparison"
    />

    <!-- access modal -->

    <b-modal
      :visible="showSelectComparisonModal"
      title="Select Report"             
      ok-title="Continue"    
      @hide="showSelectComparisonModal = false"
    >
      <b-form-select
        v-model="comparison"
        :options="comparisonOptions"
        :disabled="!isComparison"
      />
    </b-modal>

    <!-- access modal -->

    <b-modal
      id="no-access-modal"
      ref="noAccessModal"
      :hide-footer="true"
      title="Access Restricted"
    >
      Please go away!
    </b-modal>

      <!-- <b-modal
              :visible="isFirstTimeOnInform"
              size="lg"
              class="v3_modal first-time-inform-modal-popup"
              ok-only
              ok-title="Close"
              @hide="isFirstTimeOnInform = false"
              hide-header-close
              @ok="refreshPage($event)"
      >
          <p>
              This chart shows aggregate Total Cash Compensation for your specialty.
              <br><br>
              Select and apply Filters to this Measure to create cohorts of physicians just like you.
              <br><br>
              Select and apply other Measures and Filters to analyze other specialty data.
              <br><br>
              Once you know your market value go to connect to receive it.
          </p>
      </b-modal> -->
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Api, { didAbort } from '@/providers/Api.js';
import { HalfCircleSpinner } from 'epic-spinners';
import SurveySelectedCharts from '@/components/survey/SurveySelectedCharts';
import ChartsPicker from '@/components/survey/results/ChartsPicker';
import DerivedVariables from '@/providers/DerivedVariables';
import Questionnaire from '@/providers/Questionnaire.js';
import flatten from 'lodash/flatten';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import UserSettings from '@/providers/UserSettings';
import CreateComparisonModal from '@/components/comparison/CreateModal';
import {
  REPORTS_SCOPE_TYPES,
  SET_PRESENTATIONAL_QUESTIONNAIRE_MUTATION,
  SET_PRIMARY_QUESTIONNAIRE_COMPARISONS_MUTATION,
  SET_USER_QUESTIONNAIRE_MUTATION,
  SETTINGS_KEYS,
} from '@/store';
import Help from '@/providers/Help';
import ChartBuilder from '@/components/survey/results/ChartBuilder';
import ReportsPlaceholderImage from '@/components/survey/results/ReportsPlaceholderImage';
import ReportMarkdownFilters from '@/components/survey/results/report/ReportMarkdownFilters';
import ReportMarkdownCharts from '@/components/survey/results/report/ReportMarkdownCharts';
import ReportMarkdownHeading from '@/components/survey/results/report/ReportMarkdownHeading';
import FiltersSelector from '@/components/survey/results/select-filters/SelectFilters';
import PdfReportsMixin from '@/mixins/PdfReportsMixin';
import {
  isQuestionAvailableOnResultsForQuestionnaire,
  replaceCustomTagsWithDataAndHtmlTags,
} from '@/helpers/questionnaireHelper';
import QuestionnaireProvider from '@/providers/Questionnaire.js';
import SurveyResultTags from '@/components/survey/results/SurveyResultTags';
import TakeStudyWithProfileValidationBehaviour from '@/behaviours/TakeStudyWithProfileValidationBehaviour';

const putDataToFilters = (comparison, questions = [], derVars = []) => ({
  comparison: {
    ...comparison,
    charts: {
      ...comparison.charts,
      derivedVarNames: derVars,
      questionIds: questions,
    },
  },
});

const reportsQuestionsAsComparisonFactory =
  (filterCallback) =>
  (questionnaire, completedModules = [], sectionId = null) => {
    let comparison = cloneDeep(UserSettings.defaultResultCharts);  
    if(questionnaire && questionnaire.sections){
      let sections = questionnaire.sections;
      if (sectionId) {
        sections = sections.filter((s) => s.id === sectionId);
      }
      const questions = flatten(
        sections.map((section) => {
          if (!section || !section.questionSections) return [];
          if (section.is_module && !completedModules.some(cm => cm.id === section.id)) return [];
          return section.questionSections
            .filter(filterCallback)
            .map((qs) => qs.question);
        })
      );
      const [questionIds, variableIds] = questions.reduce(
        ([qIds, vIds], question) => {
          qIds.push(question.id);
          vIds = vIds.concat(question.variables.map(({ id }) => id));
          return [qIds, vIds];
        },
        [[], []]
      );
      comparison.charts.questionIds = questionIds;
      comparison.charts.variableIds = variableIds;
    }  
    return comparison;
  };

const getDisplayOnReportsQuestionsAsComparison =
  reportsQuestionsAsComparisonFactory(
    (qs) =>
      qs.question && (qs.is_included_in_default_report && qs.report_order==0)
  );

const getOnDashboardQuestionsAsComparison = reportsQuestionsAsComparisonFactory(
  (qs) => (qs.question && qs.is_on_dashboard) || (qs.question && (qs.is_included_in_default_report && qs.report_order==0))
);

const userHasDoneASurvey = (component) => {
  if (!component.$store.state.user) return false;
  const { completed_surveys: completedSurveys = [] } =
    component.$store.state.user;
  if (component.$route.params.qsId) {
    return completedSurveys.some(
      ({ questionnaire_id }) =>
        parseInt(questionnaire_id) === parseInt(component.$route.params.qsId)
    );
  } else {
    return (
      component.questionnaire &&
      completedSurveys.some(
        ({ questionnaire_id }) =>
          parseInt(questionnaire_id) === parseInt(component.questionnaire.id)
      )
    );
  }
};

const initComparisonSettings = (component) => {
  if (component.$route.params.qsId) return null;
  const questionnaire = component.$store.getters.questionnaire;
  let settings = null;
  if (!component.$store.state.primaryQuestionnaireComparisons) {
    let defaultComparisons = null;
    if (questionnaire && component.format === 'filters') {
      defaultComparisons =
        userHasDoneASurvey(component) || component.isAdminResults
          ? getDisplayOnReportsQuestionsAsComparison(questionnaire, component.modules)
          : getOnDashboardQuestionsAsComparison(questionnaire, component.modules);
    } else {
      defaultComparisons = cloneDeep(UserSettings.defaultComparisons);
    }

    settings = {
      comparisons: Array.isArray(defaultComparisons)
        ? defaultComparisons
        : [defaultComparisons],
      modules: questionnaire ? initModuleSettings(questionnaire, component.modules) : null,
    };
  }else{
    if(questionnaire != undefined)
    {
      let defaultComparisons = null;
      defaultComparisons = getDisplayOnReportsQuestionsAsComparison(questionnaire, component.modules);

      settings = {
        comparisons: Array.isArray(defaultComparisons)
          ? defaultComparisons
          : [defaultComparisons],
        modules: questionnaire ? initModuleSettings(questionnaire, component.modules) : null,
      };
    }
   
  }
  return settings;
};

const initChartInformationText = (component) => {
  if (component.$route.params.qsId) return null;
  const questionnaire = component.$store.getters.questionnaire;  
  if(questionnaire && questionnaire.sections){
    return questionnaire.sections.some(section => {
    if (section.hasOwnProperty('questionSections') && Array.isArray(section.questionSections)) {
        return section.questionSections.some(questionSection => {
            if (questionSection.report_order > 0 && (questionSection.is_on_dashboard === 0 || questionSection.is_included_in_default_report === 0)) { 
              console.log("true")                               ;
                return true;
            }
            return false;
        });
    }
    return false;
});
  }else{
    return false;
  }
  
}
const initModuleSettings = (questionnaire, completedModules) => {
  if(questionnaire && questionnaire.sections){
    const modules = getModules(questionnaire);
    const moduleSettings = {};
    modules.forEach((m) => {
      moduleSettings[m.id] = initModuleSetting(questionnaire, completedModules, m.id);
    });
    return moduleSettings;
    }
};

const initModuleSetting = (questionnaire, completedModules, moduleId) => {
  return getDisplayOnReportsQuestionsAsComparison(questionnaire, completedModules, moduleId);
};

const getModules = (questionnaire) => {
  return questionnaire.sections.filter((s) => parseInt(s.is_module) === 1);
};

export default {
  name: 'SurveyResults',
  mixins: [PdfReportsMixin],
  components: {
    SurveySelectedCharts,
    ChartsPicker,
    CreateComparisonModal,
    HalfCircleSpinner,
    ReportsPlaceholderImage,
    ChartBuilder,
    ReportMarkdownFilters,
    ReportMarkdownCharts,
    ReportMarkdownHeading,
    FiltersSelector,
    SurveyResultTags,
    TakeStudyWithProfileValidationBehaviour,
  },
  props: {
    title: String,
    format: String, // 'results' / 'filters' / 'admin-survey-results' / 'presentation'    
  },
  data: function () {
    return {
      route: this.$route.path,
      preloading: false,
      // need to create a copy of these so we can bind the 'expanded' var to each (??)
      dvVariables: DerivedVariables.userFilterVariables,
      results: {},
      // questionnaire: null,
      editedComparison: null,
      comparisonSettings: initComparisonSettings(this),
      uploadedQuestionnaire: null,
      isOptionsHidden: false,
      variableTags: null,
      scope: REPORTS_SCOPE_TYPES.STUDY,
      showNewComparisonModal: false,
      showSelectComparisonModal: false,
      takeStudyLoading: false,
      selectedSection: parseInt(this.$route.params.sectionId) || null,
      modules: [],
      // sampleType: 'random', // temporarily hidden // TODO: not implemented
        isFirstTimeOnInform: false,        
        isFirstVisit: false,
        chartThresholdSettings: 0,
        isChartInformation : initChartInformationText(this)
    };
  },
  created: function () {
    if (
      (!this.questionnaireLoading &&
        (!this.comparisonSettings || this.isPresentationResults)) ||
      !this.questionnaire
    ) {
      this.getComparisonSettings();
    }
    // if (
    //   !this.userHasDoneASurvey &&
    //   !this.isPresentationResults &&
    //   !this.isAdminResults &&
    //   !this.$route.params.qsId &&
    //   !this.questionnaireLoading
    // ) {
    //   this.scope = REPORTS_SCOPE_TYPES.SPECIALTY;
    // }
    this.refreshResults();
    this.getCompletedModules(this.questionnaire);
   
    if (!localStorage.getItem('isFirstTimeOnInform')) {
        //this.getChartSettings();
        // if(this.chartThresholdSettings < 10){
        //   this.isFirstTimeOnInform = false;  
        //   //location.reload();
        // }else{
        //   this.isFirstTimeOnInform = true;  
        // }
        //this.isFirstTimeOnInform = true;  
        localStorage.setItem('isFirstTimeOnInform', '1')
    }

    if (localStorage.getItem('IS_INFORM_POPUP_SHOW') == 1) {
      this.getChartSettings();
      if(this.chartThresholdSettings < 10){
          this.isFirstTimeOnInform = false;  
          //location.reload();
      }else{
        this.isFirstTimeOnInform = true;  
        localStorage.setItem('IS_INFORM_POPUP_SHOW', 0);
      }
      
    }

  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    isFiltersEmpty: function () {
      if (!this.comparison) return true;
      return (
        (!this.comparison.filters.derivedVarNames ||
          this.comparison.filters.derivedVarNames.length === 0) &&
        (!this.comparison.filters.variableIds ||
          this.comparison.filters.variableIds.length === 0) &&
        !this.comparison.filters.membershipType
      );
    },
    isAdminResults: function () {
      return this.format === 'admin-survey-results';
    },
    isPresentationResults: function () {
      return this.format === 'presentation';
    },
    isComparisonEmpty: function () {
      return (
        !this.comparison ||
        (!this.comparison.charts.questionIds.length &&
          !this.comparison.charts.derivedVarNames.length)
      );
    },
    isComparison: function () {
      return !!this.comparison;
    },
    userHasDoneASurvey: function () {
      return userHasDoneASurvey(this);
    },
    questionnaire: {
      get: function () {
        if (this.isPresentationResults)
          return this.$store.getters.presentationalQuestionnaire;
        else if (this.$route.params.qsId) return this.uploadedQuestionnaire;
        return this.$store.getters.questionnaire;
      },
      set: function (questionnaire) {
        if (this.isPresentationResults)
          this.$store.commit(
            SET_PRESENTATIONAL_QUESTIONNAIRE_MUTATION,
            questionnaire
          );
        else if (this.$route.params.qsId)
          this.uploadedQuestionnaire = questionnaire;
        else this.$store.commit(SET_USER_QUESTIONNAIRE_MUTATION, questionnaire);
      },
    },
    comparisons: {
      get: function () {
        const settings = this.comparisonSettings;
        return settings && settings.comparisons
          ? settings.comparisons
          : UserSettings.defaultComparisons;
      },
      set: function (comparisons) {
        this.$set(this.comparisonSettings, 'comparisons', comparisons);
      },
    },
    comparison: {
      get: function () {
        if (this.selectedSection) {
          const { modules } = this.comparisonSettings || {};
          return (modules || {})[this.selectedSection];
        }
        if (!this.comparisons || !this.comparisons.length) {
          return null;
        }
        // otherwise show the selected one (this gets overridden on the Results
        // page, so only applies to the Compare page)
        let selectedComparison = this.comparisons
          ? this.comparisons.find((c) => c.selected)
          : [];
        if (!selectedComparison) {
          selectedComparison = this.comparisons[0];
        }
        return selectedComparison;
      },
      set: function (comparison) {
        const { comparisons } = this.comparisonSettings || {};
        (comparisons || []).forEach((c) => {
          c.selected = Object.is(c, comparison);
        });
      },
    },
    comparisonTitle: {
      get: function () {
        return this.comparison ? this.comparison.title : null;
      },
      set: function (val) {
        this.comparison.title = val;
      },
    },
    comparisonOptions: function () {
      return (
        (this.comparisonSettings && this.comparisonSettings.comparisons) ||
        []
      ).map((s) => {
        return { value: s, text: s.title };
      });
    },
    scopeOptions: function () {
      const options = [
        {
          value: REPORTS_SCOPE_TYPES.STUDY,
          text: 'All Study Responses',
          disabled:
            !this.userHasDoneASurvey &&
            !this.isPresentationResults &&
            !this.isAdminResults,
        },
      ];
      if (this.user && this.user.specialty_id && !this.isAdminResults) {
        options.push({
          value: REPORTS_SCOPE_TYPES.SPECIALTY,
          text: this.user.specialty.title,
        });
      }
      if (this.user && this.user.subspecialty_id && !this.isAdminResults) {
        options.push({
          value: REPORTS_SCOPE_TYPES.SUB_SPECIALTY,
          text: this.user.subspecialty.title,
          disabled: !this.userHasDoneASurvey,
        });
      }
      return options;
    },
    questions: function () {
      if (!this.questionnaire) {
        return [];
      }
      const qs = flatten(
        (this.questionnaire.sections || []).map((section) => {
          if (!section || !section.questionSections) return [];
          return section.questionSections
            .filter(
              (qs) => {
                if(!this.isFirstVisit){
                  return !!qs.question &&
                 (qs.is_available_on_results || (qs.is_included_in_default_report && qs.report_order==0));
                }else{
                  return !!qs.question;
                }
              }
                
            )
            .map((qs) => qs.question);
        })
      );
      return keyBy(qs, (q) => q.id);
    },
    variables: function () {
      if (!this.questionnaire) {
        return [];
      }
      const vs = flatten(
        Object.values(this.questions).map((question) => {
          return question.variables;
        })
      );
      return keyBy(vs, (v) => v.id);
    },
    filterQuestions: function () {
      if (!this.comparison || !this.questionnaire) {
        return [];
      }
      return map(this.comparison.filterQuestionIds, (qid) => {
        return this.questions[qid];
      });
    },
    filterDerivedVars: function () {
      if (!this.comparison) {
        return [];
      }
      return map(this.comparison.filterDerivedVarNames, (dvName) => {
        return this.dvVariables[dvName];
      });
    },
    // if we're in filter mode, sort the results in the order of this.questionIds,
    // rather than the default order by question ID as returned from the API
    resultsSorted: function () {
      let results = Array.isArray(this.results) ? this.results : [];
      if (this.comparison) {
        const sections = (this.questionnaire || {}).sections || [];
        const selectedQsIds = (this.comparison.charts || {}).questionIds || [];
        const selectedVIds = (this.comparison.charts || {}).variableIds || [];
        const filter = QuestionnaireProvider.getQuestionnaireSections(
            sections,
            selectedQsIds,
            selectedVIds
          );

        
        const mergedQuestions = filter.reduce((accumulator, currentValue) => {
          return accumulator.concat(currentValue.questions);
        }, []);
        const baseArray = mergedQuestions;
        results.sort((a, b) => {
            if (a.id === "userSpecialtyId") return -1;
            if (b.id === "userSpecialtyId") return 1;

            return baseArray.findIndex(item => item.question.id === a.id) - baseArray.findIndex(item => item.question.id === b.id);
        });

        results = results.filter((res) => {
          return (
            (this.comparison.charts.questionIds.includes(res.id) &&
              isQuestionAvailableOnResultsForQuestionnaire(
                res.id,
                this.questionnaire
              )) ||
            this.comparison.charts.derivedVarNames.includes(res.id)
          );
        });
      }
      // console.log('====');
      // console.log(JSON.stringify(results.filter((r) => !!r && !!r.id)));
      // todo: add ordering here when will be implemented
      return results.filter((r) => !!r && !!r.id);
    },
    pageTitle: function () {
      return `${(this.questionnaire || {}).period || ''} ${
        (this.questionnaire || {}).title || ''
      }`;
    },
    comparisonTitles: function () {
      return this.comparisons ? this.comparisons.map((c) => c.title) : [];
    },
    comparisonLimit: function () {
      const limit = this.$store.state.settings.comparison_limit || 10;
      return parseInt(limit);
    },
    favorites: function () {
      return this.questionnaire && this.questionnaire.favorites
        ? JSON.parse(this.questionnaire.favorites)
        : null;
    },
    isQuestionnaireSupportsReports: function () {
      return (
        this.format !== 'filters' ||
        (this.questionnaire &&
          parseInt(this.questionnaire.is_support_report) === 1)
      );
    },
    isQuestionnaireNotSupportsReports: function () {
      return (
        this.questionnaire &&
        this.format === 'filters' &&
        parseInt(this.questionnaire.is_support_report) === 0
      );
    },
    isMembershipSectionVisible: function () {
      return (
        this.isAdminResults &&
        Array.isArray(this.questionnaire.societyMembershipTypes) &&
        this.questionnaire.societyMembershipTypes.length > 1
      );
    },
    membershipOptions: function () {
      if (!this.isMembershipSectionVisible) return [];
      return this.questionnaire.societyMembershipTypes.map(
        ({ id, type_name }) => ({
          text: type_name,
          value: id,
        })
      );
    },
    questionnaireStartDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.start_date).format('MMM D, YYYY')
        : '';
    },
    questionnaireClosedDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.end_date).format('MMM D, YYYY')
        : '';
    },
    numberOfSelectedQuestions: function () {
      if (!this.comparison || !this.questions) {
        return [];
      }
      const questionIds = (this.comparison.charts || {}).questionIds || [];
      return Object.values(this.questions).filter(
        ({ id }) =>
          questionIds.includes(id) &&
          isQuestionAvailableOnResultsForQuestionnaire(id, this.questionnaire)
      ).length;
    },
    resultTitles: function () {
      return this.resultsSorted.map((res) => res.chart_title);
    },
    getResultsFunction: function () {
      return this.isPresentationResults
        ? Api.getPresentationResults
        : this.$store.getters.userIsNonMSSUser
        ? Api.getNonSocietySurveyResults
        : Api.getSurveyResults;
    },
    chartFormat: function () {
      return this.userHasDoneASurvey ||
        this.isPresentationResults ||
        this.isAdminResults
        ? this.format
        : 'no-study-completed';
    },
    sampleReportLink: function () {
      const storePath = this.$store.getters.getSetting(
        SETTINGS_KEYS.ASSETS_STORE_URL
      );
      return storePath ? `${storePath}/SampleReport.pdf` : '#';
    },
    sectionOptions: function () {
      const allOption = { value: null, text: 'All' };
      if (!this.modules) return [allOption];
      const options = this.modules.map((m) => ({
        value: m.id,
        text: m.title,
      }));
      options.unshift(allOption);
      return options;
    },
    questionnaireLoading: function () {
      return this.$store.state.userQuestionnaireLoading;
    },
    specialty: function () {
      return this.user && this.user.specialty;
    },
    specialtyTitle: function () {
      return this.specialty && this.specialty.title;
    },
    subspecialty: function () {
      return this.user && this.user.subspecialty;
    },
    subspecialtyTitle: function () {
      return this.subspecialty && this.subspecialty.title;
    },
  },
  methods: {
    refreshPage: function () {
    //   location.reload();
    this.$nextTick(() => {
        this.refreshResults();
        this.getVariableTags();
      });
    },
    preloadQuestion: function (index) {
      return !this.preloading || index < 4;
    },
    cloneComparison: function () {
      if (this.comparisons.length >= this.comparisonLimit) {
        this.$toasted.info(
          `Only ${this.comparisonLimit} reports are allowed. You can delete an existing report and try again.`,
          {
            duration: 3000,
          }
        );
        return;
      }
      if (!this.comparison) {
        this.$toasted.info('There is no Report to be cloned.', {
          duration: 3000,
        });
        return;
      }
      const newComparison = cloneDeep(this.comparison);
      newComparison.title = 'Copy of ' + newComparison.title;
      this.comparisons.push(newComparison);
      this.comparison = newComparison;
    },
    newComparison: function () {
      if (this.comparisons.length >= this.comparisonLimit) {
        this.$toasted.info(
          `Only ${this.comparisonLimit} reports are allowed. You can delete an existing report and try again.`,
          {
            duration: 3000,
          }
        );
        return;
      }
      this.editedComparison = null;
      this.showNewComparisonModal = true;
    },
    onEditComparison: function () {
      this.editedComparison = this.comparison;
      this.showNewComparisonModal = true;
    },
    onModalSave: function (newTitle) {
      const index = this.comparisons.findIndex(
        (c) => c.title === (this.editedComparison || {}).title
      );

      let message = 'Reports saved successfully.';

      if (index !== -1) {
        this.$set(this.comparisons[index], 'title', newTitle);
      } else {
        const newComparison = cloneDeep(
          UserSettings.defaultComparisons[0] || {}
        );
        newComparison.title = newTitle;
        this.$set(this.comparisons, this.comparisons.length, newComparison);

        this.comparison = newComparison;

        message = 'Reports created successfully.';
      }

      this.saveComparison();

      this.editedComparison = null;

      this.showNewComparisonModal = false;

      this.$toasted.success(message, {
        duration: 3000,
      });
    },
    onCancelComparison: function () {
      this.editedComparison = null;
      this.showNewComparisonModal = false;
    },
    onDeleteComparison: function () {
      if (this.comparisons.length === 1) {
        this.$toasted.error(
          'Delete not allowed, at least one report must be active.',
          {
            duration: 6000,
            action: {
              icon: 'mdi mdi-close-circle toaster-close-icon',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
        return;
      }
      Help.confirm.show(
        `Are you sure you want to delete the '${this.comparison.title}' report?`,
        'Yes',
        () => {
          this.deleteComparison();
        }
      );
    },
    deleteComparison: function () {
      this.comparisons = (this.comparisons || []).filter(
        (comp) => !comp.selected
      );
      this.comparison = this.comparisons[0];
      this.saveComparison();
      this.$toasted.success('Report deleted successfully.', {
        duration: 3000,
      });
    },
    removeDerVar: function (derVar) {
      this.$delete(
        this.comparison.charts.derivedVarNames,
        this.comparison.charts.derivedVarNames.indexOf(derVar.id || derVar.name)
      );
      this.saveComparison();
    },
    removeQuestionFromCharts: function (questionToRemove) {
      const qid = (questionToRemove || {}).id;
      this.$delete(
        this.comparison.charts.questionIds,
        this.comparison.charts.questionIds.indexOf(qid)
      );
      // remove varIDs also
      const questionnaire = this.questionnaire;
      const question = Questionnaire.findQuestion(questionnaire, qid);
      (question.variables || []).forEach(({ id: vId = null }) => {
        this.$delete(
          this.comparison.charts.variableIds,
          this.comparison.charts.variableIds.indexOf(vId)
        );
      });

      this.questionnaire = {...this.questionnaire};
      this.saveComparison();
    },
    uploadResultsForAdmin: async function () {
      if (
        this.comparison &&
        this.comparison.charts &&
        (this.comparison.charts.questionIds.length > 2 ||
          this.comparison.charts.derivedVarNames.length > 2)
      ) {
        const { firstReqFilters, secondReqFilters, afterFetch, catchError } =
          this.splitOnTwoRequests();
        this.preloading = true;
        Api.getSurveyResultsForAdmin(
          this.$route.params.qsId,
          firstReqFilters,
          this.scope
        )
          .then(afterFetch)
          .catch(catchError);
        Api.getSurveyResultsForAdmin(
          this.$route.params.qsId,
          secondReqFilters,
          this.scope
        )
          .then(afterFetch)
          .catch(catchError);
      } else {
        let filters = {
          comparison: this.comparison,
        };
        if (!this.comparisonSettings) {
          // don't fetch results if comparison is not loaded yet
          // (this can happen when dashboard is first loading)
          return;
        }
        try {
          const { questionnaire, results } = await Api.getSurveyResultsForAdmin(
            this.$route.params.qsId,
            filters,
            this.scope
          );
          this.results = results;
          this.questionnaire = questionnaire;
        } catch (error) {
          if (error && error.response && error.response.data) {
            this.$toasted.error(error.response.data.message, {
              duration: 3000,
            });
          } else {
            this.$toasted.error('Unable to upload results', { duration: 3000 });
          }
        } finally {
          this.preloading = false;
        }
      }
    },
    onFiltersApply: function (filtersData) {
      const { filterValues, filters } = filtersData;
      this.$set(this.comparison, 'filterValues', filterValues);
      this.$set(this.comparison, 'filters', filters);
      this.$nextTick(() => {
        this.refreshResults();
        this.getVariableTags();
      });
    },
    refreshResults: async function () {
      this.results = [];
      if (!this.isQuestionnaireSupportsReports || !this.questionnaire) {
        return;
      }

      if (!this.comparisonSettings) {
        return;
      } else if (this.isAdminResults) {
        this.uploadResultsForAdmin();
      } else if (
        this.comparison &&
        this.comparison.charts &&
        (this.comparison.charts.questionIds.length > 2 ||
          this.comparison.charts.derivedVarNames.length > 2)
      ) {
        this.sendTwoRequests();
      } else {
        let filters = {
          comparison: this.comparison,
        };
        this.preloading = true;
        try {
          const { results, questionnaire } = await this.getResultsFunction(
            this,
            'getSurveyResults',
            filters,
            this.$route.params.qsId,
            this.scope,
              this.selectedSection
          );
          this.results = results;
          this.questionnaire = questionnaire;
        } catch (e) {
          if (!didAbort(e)) throw e;
        } finally {
          this.preloading = false;
        }
      }
      this.saveComparison();
    },

    // when we're showing one chart per variable on a question,
    // only give the chart a title if there is > 1 variable
    getVariableChartTitle: function (q, varLabel) {
      if (q && q.question && q.question.variablesCount === 1) {
        return '';
      } else {
        return varLabel;
      }
    },
    splitOnTwoRequests: function () {
      let firstFetched = false;
      const afterFetch = ({ results, questionnaire }) => {
        if (!firstFetched) {
          firstFetched = true;
          this.results = results;
          this.questionnaire = questionnaire;
        } else {
          this.results.push(...results);
          this.preloading = false;
        }
      };
      const catchError = (error) => {
        if (firstFetched) {
          this.preloading = false;
        } else {
          firstFetched = true;
        }
        if (didAbort(error)) return;
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$toasted.error(error.response.data.message, { duration: 3000 });
        } else {
          this.$toasted.error(
            'Unable to load some data, please try again later',
            { duration: 3000 }
          );
        }
      };
      let firstReqFilters = null;
      let secondReqFilters = null;
      if (this.comparison.charts.questionIds.length > 2) {
        const [firstQuestionId, secondQuestionId, ...restOfQuestions] =
          this.comparison.charts.questionIds;
        firstReqFilters = putDataToFilters(
          this.comparison,
          [firstQuestionId, secondQuestionId],
          []
        );
        secondReqFilters = putDataToFilters(
          this.comparison,
          restOfQuestions,
          this.comparison.charts.derivedVarNames
        );
      } else {
        const [firstDerVar, secondDerVar, ...restDerVars] =
          this.comparison.charts.derivedVarNames;
        firstReqFilters = putDataToFilters(
          this.comparison,
          [],
          [firstDerVar, secondDerVar]
        );
        secondReqFilters = putDataToFilters(
          this.comparison,
          this.comparison.charts.questionIds,
          restDerVars
        );
      }
      return {
        firstReqFilters,
        secondReqFilters,
        afterFetch,
        catchError,
      };
    },

    sendTwoRequests: function () {
      const { firstReqFilters, secondReqFilters, afterFetch, catchError } =
        this.splitOnTwoRequests();
      this.preloading = true;
      this.getResultsFunction(
        this,
        'getSurveyResults1',
        firstReqFilters,
        this.$route.params.qsId,
        this.scope
      )
        .then(afterFetch)
        .catch(catchError);
      this.getResultsFunction(
        this,
        'getSurveyResults2',
        secondReqFilters,
        this.$route.params.qsId,
        this.scope
      )
        .then(afterFetch)
        .catch(catchError);
    },
    getComparisonSettings: async function () {
      const qId = this.$route.params.qsId || (this.questionnaire || {}).id;
      if (!qId) return;
      try {
        this.$wait.start(this.$options.name + '_loading');
        this.preloading = true;
        const comparisonSettingsData = await (this.isPresentationResults
          ? Api.getPresentationComparisonSettings()
          : Api.getQuestionnaireComparisonSettings(qId));
        const { comparisons: comparisonsSettings, questionnaire } =
          comparisonSettingsData || {};
        let { comparisons } = comparisonsSettings || {};
        this.comparisonSettings = {
          comparisons:
            this.isPresentationResults || this.userHasDoneASurvey
              ? comparisons || [
                  getDisplayOnReportsQuestionsAsComparison(questionnaire, this.modules),
                ]
              : [getOnDashboardQuestionsAsComparison(questionnaire, this.modules)],
          modules: initModuleSettings(questionnaire, this.modules),
        };
        if (!this.questionnaire && questionnaire) {
          this.questionnaire = questionnaire;
        }
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
        this.$toasted.error('Unable to upload data, please try again later', {
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.$options.name + '_loading');
        this.preloading = false;
      }
    },
    saveComparison: debounce(async function () {
      if (
        this.isPresentationResults ||
        (!this.userHasDoneASurvey && !this.isAdminResults)
      )
        return;
      const qId = this.$route.params.qsId || (this.questionnaire || {}).id;
      try {
        await Api.updateQuestionnaireComparisons(
          qId,
          JSON.stringify(this.comparisonSettings)
        );
        if (!this.isAdminResults && !this.$route.params.qsId) {
          this.$store.commit(
            SET_PRIMARY_QUESTIONNAIRE_COMPARISONS_MUTATION,
            this.comparisonSettings
          );
        }
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
      }
    }, 1000),
    onChartsSelected: function (comparisonCharts) {
      this.isFirstVisit = true;
      this.comparison.charts = comparisonCharts;
      this.refreshResults();
    },
    onTooltipMouseOver: function (i) {
      this.$refs.chart_question_tooltips[i].$emit('open');
    },
    onTooltipMouseOut: function (i) {
      this.$refs.chart_question_tooltips[i].$emit('close');
    },
    onClearAll: function () {
      const { filterValues, filters } = this.$refs.filtersSelector.getFilters();
      this.$set(this.comparison, 'filterValues', filterValues);
      this.$set(this.comparison, 'filters', filters);

      this.onFiltersApply();
    },
    onRemoveTag: function (removedTag) {
      this.$refs.filtersSelector.updateFiltersByTag(removedTag);
    },
    onTagClearAll: function () {
      if (
        this.$refs.filtersSelector &&
        typeof this.$refs.filtersSelector.onClearAll === 'function'
      ) {
        this.$refs.filtersSelector.onClearAll();
      }
    },
    getVariableTags: function () {
      if (
        !this.$refs.filtersSelector ||
        typeof this.$refs.filtersSelector.getTags !== 'function'
      ) {
        this.variableTags = null;
        console.info('filters block is not specified');
      } else {
        this.variableTags = this.$refs.filtersSelector.getTags();
      }
    },
    getCompletedModules: async function (questionnaire) {
      if (!questionnaire) return;
      this.modules = await Api.getCompletedModules(questionnaire.id);
    },
    getChartSettings: async function () {          
    var getAdminSetting = await Api.getSettings();  
      this.chartThresholdSettings = getAdminSetting.chart_valid_threshold;  
      if(this.chartThresholdSettings < 10){
        //location.reload();
        this.isFirstTimeOnInform = false;
      }else{     
        if (localStorage.getItem('IS_INFORM_POPUP_SHOW') == 1) { 
          this.isFirstTimeOnInform = true;
          localStorage.setItem('IS_INFORM_POPUP_SHOW', 0);
        }else{
          this.isFirstTimeOnInform = false;
        }
      } 
    },
    replaceCustomTags: function (text) {
      return replaceCustomTagsWithDataAndHtmlTags(text);
    },
  },
  watch: {
    $route: function () {
      this.refreshResults();     
    },
    comparison: function () {
      // refresh results on first load, but not in response to filter changes
      // (for those, must click Apply button)
      this.refreshResults();
      this.$nextTick(() => {
        this.getVariableTags();
      });
    },
    questionnaire: function (newQuestionnaire, oldQuestionnaire) {
      this.userHasDoneASurvey && this.getCompletedModules(newQuestionnaire);
      if (newQuestionnaire && !oldQuestionnaire) {
        this.comparisonSettings = initComparisonSettings(this);
        if (!this.comparisonSettings || this.isPresentationResults) {
          this.getComparisonSettings();
        }
      }
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->
<style scoped>
.box-body-color-padding {
  background-color: rgba(2, 22, 35, 0.025);
  padding: 2rem;
  min-height: 400px;
}
@media (min-width: 320px) and (max-width: 768px) {
  .mobile-reponsive-heading {
    text-align: center !important;
  }
  .mobile-reponsive-padding-box {
    padding: 0 15px !important;
  }
  .mobile-reponsive-box-body-padding {
    padding: 10px !important;
  }
  .box-body-color-padding {
    padding: 0.7rem !important;
  }
  .mobile-header-content-center {
    text-align: center !important;
  }
}
</style>
<style lang="scss">
@import '../../../../sass/variables_mixins.scss';
@import '../../../../sass/v3.scss';

.survey-results__loading-indicator {
  position: fixed;
  bottom: 75px;
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: 768px) {
    width: 100%;
  }

  .alert.alert-warning {
    color: inherit;
    font-weight: bold;
    background-color: #beccd541;
    border-color: $phairify_primary_border_color;
  }

  .survey-results__loading-indicator__icon-wrapper {
    display: inline-block;
    position: relative;
    width: $phairify_icon-size_large;
    height: $phairify_icon-size_large;

    .material-design-icon {
      position: absolute;
      top: 3px;
    }
  }
}

.first-time-inform-modal-popup .modal-footer button{
  max-width: 100px !important;
  width: 100% !important;
  margin: 0 auto !important;
}

.survey-results .highcharts-container {
  margin: auto;
}

.survey-results__question-prompt {
  width: calc(100% - 30px);
  @include phairify_heading_not_bold_18;
}

.survey-results__question-id {
  position: absolute;
  bottom: 5px;
  left: 10px;
  color: #bbb;
}

.survey-results__button {
  svg.icon {
    fill: #fff !important;
    width: 12px;
    height: 12px;
  }
}

.survey-results__apply-button {
  font-weight: bold;

  svg.icon {
    fill: #fff !important;
    margin-left: 5px;
  }
}

.survey-results {
  min-width: 360px;

  .width_107 {
    width: 107px;
  }

  .survey-results__title {
    @include phairify_heading_bold_18;
  }

  .survey-results__menus_wrapper {
    flex: 0 0 430px;
    @media (max-width: 1200px) and (min-width: 768px) {
      flex: 0 0 320px;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .survey-results__charts-wrapper {
    flex: 1 1 auto;
  }

  .survey-results__card_title {
    @include phairify_heading_bold_18;
    color: $phairify_primary_color_navy;
  }

  .survey-results__content {
    .survey-results__menu-card {
      @include phairify_card_with_padding;
      min-height: calc(100vh - 200px);
    }
  }

  .survey-results__edit-comparison-btn {
    line-height: 32px;
  }

  .alert {
    i.mdi {
      color: inherit;
    }
  }

  .material-design-icon {
    height: $phairify_icon-size_large;
    width: $phairify_icon-size_large;
  }

  .material-design-icon > .material-design-icon__svg {
    height: $phairify_icon-size_large;
    width: $phairify_icon-size_large;
    fill: $phairify_primary_color_icon;
  }

  .survey-results__poll-icon {
    margin-right: 0;
  }

  .survey-results__icon-wrapper {
    @media (min-width: 576px) {
      margin-right: 5px;
    }

    i.mdi {
      line-height: 15px;
    }

    i.mdi:before {
      position: relative;
      top: 3px;
    }
  }

  .survey-results__selected-chart {
    padding-bottom: 0;
    @include phairify_body_copy;

    label {
      font-weight: normal;
    }
  }

  .btn.btn-secondary {
    @include phairify_white_button;
  }

  .btn.btn-danger {
    @include phairify_danger_button;
  }

  .survey-results__empty-info-wrapper,
  .survey-results__create-comparison-info-wrapper {
    height: 51px;

    .survey-results__empty-info-text {
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      height: 36px;
      vertical-align: middle;
      color: rgba($phairify_primary_color_icon, 0.5);

      i.mdi {
        font-size: 36px;
        color: rgba($phairify_primary_color_icon, 0.5);
      }
    }

    @media (max-width: 768px) {
      i.mdi {
        display: none;
      }
    }

    &.with-margin {
      @media (min-width: 721px) {
        margin-top: 188px;
      }
    }
  }

  .survey-results--modal-dialog {
    max-width: 425px;
    @media (max-width: 575px) {
      max-width: 360px;
    }
  }

  .survey-results--filter-buttons {
    .btn.btn-filter {
      @include phairify_body_copy;
      border: none;
      border-radius: 0;
      background-color: $phairify_primary_border_color;
      color: $phairify_secondary_color_grey;

      &.active {
        background-color: rgba($phairify_secondary_color_lime, 0.25);
        color: #000000;
      }
    }
  }

  .survey-results__input-label {
    @include phairify_body_copy;
    font-weight: bold;
    color: $phairify_primary_color_teal;
  }

  .min-width-142-px {
    min-width: 142px !important;
  }

  .with-instruction {
    position: relative;

    .instruction {
      /*position: absolute;*/
      top: 15px;
      left: 130%;
      width: 45vw;
      display: flex;
      align-items: center;
      color: $phairify_secondary_color_grey;
      font-weight: 600;
      @extend .font_size_1125rem;

      i.mdi {
        font-size: $phairify_icon-size_xl;
        color: rgba($phairify_secondary_color_grey, 0.5);
      }
    }

    @media (max-width: 768px) {
      margin-bottom: 60px !important;
      .instruction {
        top: 102%;
        left: 0;
        width: 100%;
        transform: none;
        position: initial;
      }
    }
  }

  .survey-results__remove-chart {
    &:hover {
      cursor: pointer;
    }

    i.mdi.size-medium {
      font-size: 22px;
      line-height: 22px;
    }
  }

  .report-markdown-wrapper {
    width: 1240px !important;
    min-height: 3488px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -99;
  }

  .phairify-select-wrapper {
    &:after {
      font-size: 22px;
      right: 10px;
    }

    .custom-select {
      height: 100%;
      padding: 10px;
    }
  }
}
.downloading-report-span {
  color: #c2d500 !important;
}
/*.font-note{
  font-size:14px;
  color:#888;
}*/
</style>